import { handleActions } from 'redux-actions';
import {
  SOCKET_CONNECT,
  SOCKET_CONNECT_CANCEL,
  SOCKET_DISCONNECTED,
  SOCKET_CONNECTED,
  socketEmit,
  socketEvent,
  SOCKET_CONNECT_SUCCESS,
  SOCKET_CONNECT_ANONYMOUS,
  SOCKET_CONNECT_AUTH_CUSTOMER,
} from './actions';

// eslint-disable-next-line no-unused-vars
function handleSocketEmission(state, { payload: { eventName, args } }) {
  return state;
}

// eslint-disable-next-line no-unused-vars
function handleSocketEvents(state, { payload: { eventName, args } }) {
  return state;
}

export default handleActions(
  {
    [socketEmit]: handleSocketEmission,
    [socketEvent]: handleSocketEvents,
    [SOCKET_CONNECT]: state => ({ ...state, connecting: true }),
    [SOCKET_CONNECT_CANCEL]: state => ({ ...state, connecting: false }),
    [SOCKET_CONNECT_ANONYMOUS]: state => ({ ...state, connecting: true }),
    [SOCKET_CONNECT_AUTH_CUSTOMER]: state => ({ ...state, connecting: true }),
    [SOCKET_CONNECT_SUCCESS]: (state, { payload: { token, expires } }) => ({ ...state, token, tokenExpires: expires }),
    [SOCKET_CONNECTED]: state => ({ ...state, isConnected: true, connecting: false }),
    [SOCKET_DISCONNECTED]: state => {
      return { ...state, token: undefined, tokenExpires: undefined, isConnected: false, connecting: false };
    },
  },
  { token: undefined, tokenExpires: undefined, isConnected: false, connecting: false }
);
